module.exports = __webpack_public_path__ + "img/zoom-out.0151d646.svg";